<template>
<div >

<h4>PREZZO DI ACQUISTO E VENDITA</h4>
<div class="table-responsive-sm mt-1">              
<table class="table table-bordered table-sm" id="priceDetail">
    <thead class="thead-light">
    <tr>
        <th class="text-center"  v-bind:style="{ color: index > 0 ? 'black':'blue', backgroundColor : index > 0 ? '#9ACD32':'' }" v-for="(key,index) in cols" :key="index">
              
        <span
         v-bind:style="{ color:  key!='COLORE'? 'black':'blue'}"
         >{{key.toUpperCase()}}</span>
        </th>
    </tr>
    </thead>
    <tbody>
      <tr v-for="(entry, index1) in items" :key="index1">
        <td v-for="(key,index2) in cols" :key="index2" >
            <div v-if = "key != 'Listino'">
                <input v-on:keydown="keyHandler($event,'Dec')" v-model = "entry[key]" class="form-control inputClass"  v-bind:name="entry['Listino'] + '|' + index2 " type="number" placeholder="" :disabled="key=='Listino'">
            </div>
            <div v-else >
                <div class="input-group mb-3">
                <input v-on:keydown="keyHandler($event,'Dec')" @change="setMarkUp()" v-focus class="form-control"  v-bind:name="'price_' + entry['Listino']" type="number" v-bind:placeholder="'Prezzo di ' + entry['Listino'] + ' base'">
                <div class="input-group-append">
                    
                    <span @click="repeatPrice(index1)" class="input-group-text pointer" data-toggle="tooltip"  title="Ripeti prezzo per ogni misura"><i class="fas fa-clone mr-2" aria-hidden="true"></i></span>
                  </div>
                 </div>
                
          </div>
        </td>
      </tr>
    </tbody>
</table>

<div class="row ml-3">

<discount-list v-if="refresh" v-bind:discounts="discounts" @update="setDiscountList"></discount-list>
</div>

<markup class="mt-3" :key="markUpKey" v-bind:price1="price1" v-bind:price2="price2" ></markup>



  <alert-box class="mt-1 mb-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
  <button :disabled="spinner" @click="submit()"  class="btn btn-primary float-right mr-4">
    
     
      <i style="color:yellow" class="fas fa-save mr-2" aria-hidden="true"></i>
      
    TERMINA
    <span v-if="spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
  </button>
  
 </div>
</div> 
</template>

<script>


import alertBox         from '@/components/common/AlertBox.vue';
import markup           from '@/components/common/MarkUp.vue';
import api              from '@/api'
import keyHandler       from   '@/components/mixins/keyHandler'
import discountList     from '@/components/backOffice/ready/DiscountList.vue'



export default {
   components: {alertBox,markup,discountList},  
   props: ['orderId','productId'],
   mixins: [keyHandler],
  data () {
    return {
     price1    : 0,
     price2    : 0,
     markUpKey : 0,
         
     priceList : [],
     cols      : [],
     items     : [],
   
     spinner   : false,
     
     msg       : {
       title : '',
       body  : '',
       type  : 0
     },
     
     
     refresh   : false,
     discounts : [],
     discountList : {}

    }
  },
  

  
   directives: 
    {
      focus: {
      // directive definition
      inserted: function (el) 
      {
        if(el.name=='price_acquisto')
        {
         el.focus() 
        }
      }
      }
    },
  mounted()
    {
      //$('input:visible:enabled:first').focus();  
    },
  created()
  {
    this.getData()
  },

  methods: 
  {
    setDiscountList(d1,d2,d3)
    {
      
      this.discountList.discount = d1
      this.discountList.discount2 = d2
      this.discountList.discount3 = d3

    },
    setMarkUp()
    {    
      this.price1 = document.getElementsByName("price_acquisto")[0].value
      this.price2 = document.getElementsByName("price_vendita")[0].value
      this.markUpKey++
    },
    async getData()
    {
     
        var data      = {'orderId' : this.orderId, 'productId' : this.productId}
        var sp        = {'sp' : 'spOrderProductPriceList'}
        var json      = Object.assign(data, sp);

        await api.post(json).then(res => {
          if(res.status==200)
            {
              this.priceList = res.data.recordsets 
              this.createItems(this.priceList)
             
               
               this.discountList.discount = res.data.recordsets[0][0].discount
               this.discountList.discount2 = res.data.recordsets[0][0].discount2
               this.discountList.discount3 = res.data.recordsets[0][0].discount3
               
               this.discounts.push({
                'discount':res.data.recordsets[0][0].discount,'order_by':1
              }) 
              this.discounts.push({
                'discount':res.data.recordsets[0][0].discount2,'order_by':2
              })
              this.discounts.push({
                'discount':res.data.recordsets[0][0].discount3,'order_by':3
              })
              this.refresh = true

            }
            else if(res.status==500)
            {
             
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1  
            } 
            else
            {
             
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                   
            } 
        }).catch(err => 
        {
          
          this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1  
        }).finally(() => {
          this.spinner = false
        });
       

        
    },

    formatEuro(v)
    {
      var formatter = new Intl.NumberFormat('de-DE', {
      //style      : 'currency',
      minimumFractionDigits : 2, 
      maximumFractionDigits : 2,
      currency              : 'EUR',
    });

      return formatter.format(v); 
    },

    submit() 
    {
      

      this.msg.title = ''
      let err = false
      this.items.forEach(row => {
      var priceList = row.Listino
      
      Object.entries(row).forEach(item => {
          let key   = item[0]
          let value = item[1]
          if (key != 'Listino')
          {
            if(this.formatEuro(value) == '0,00')
            {
              this.msg.title = 'ATTENZIONE '
              this.msg.body = 'Prezzo di ' + priceList + ' mis [ ' + key  + ' ] non valido.'
              this.msg.type = 1
              err = true
            }
          }
        })
      })

      if(!err)
      {
        this.checkList()
      }    

    },  
    createItems(items)
    {
      
    
      this.cols    = []
      this.items   = []
      this.cols.push('Listino')  
      var obj = {}
      
      items[0].forEach(item=>{        
        this.cols.push(item.size)
      })

      obj = {'Listino' : 'acquisto'}
      items[0].forEach(item =>
      {
       
        obj[item.size] = item.cost_price; 

      })

      this.items.push(obj)
      obj = {'Listino':'vendita'}
      items[1].forEach(item =>
      {
       
        obj[item.size] = item.price; 
      })

      this.items.push(obj)
        

    },
    repeatPrice(index)
    {
      var costPrice     = document.getElementsByName("price_acquisto")[0].value
      var retailPrice   = document.getElementsByName("price_vendita")[0].value
      if(index==0)
      {
        if(this.formatEuro(costPrice)=='0,00')
        {
          this.msg.title = 'ATTENZIONE '
          this.msg.body = 'Prezzo di acquisto base non valido.'
          this.msg.type = 1
          
          return     
        }
      }
      if(index==1)
      {
        if(this.formatEuro(retailPrice)=='0,00')
        {
          this.msg.title = 'ATTENZIONE '
          this.msg.body = 'Prezzo di vendita base non valido.'
          this.msg.type = 1
          
          return     
        }
      }
      if (index==0)
      {
        this.cols.forEach(col =>
        {              
          if (col != 'Listino')
          {
            this.items[0][col] = parseFloat(costPrice).toFixed(2)   
          }    
        })
      }
      else
      {
        this.cols.forEach(col =>
        {  
          if (col != 'Listino')
          {
            this.items[1][col] = parseFloat(retailPrice).toFixed(2)
          }
        })
      }
    },
    checkList()
    {
     
      const updatePriceList = (key,value,priceList) =>
      {
        this.priceList.forEach(item =>
        {
          if(priceList=='acquisto')
          {
          item.forEach(row => {
          if(row.size == key && row.priceList == 0 )
          {
            row.cost_price     = value
              //item.discount       = this.discount
              //item.vat            = this.vat
          }  
          })
          }
            
          if(priceList=='vendita')
          {
          item.forEach(row => {
          if(row.size == key && row.priceList == 1)
          {
            row.price = value
          }  
          })
          }
          

        })
      }

      this.items.forEach(e =>{
      var priceList = e.Listino
      //console.log(priceList)
      Object.entries(e).forEach(item => {
        let key   = item[0]
        let value = item[1]

        //use key and value here
        if (key != 'Listino')
        {
          updatePriceList(key,value,priceList)
        }
      })
      })
      
      
        this.updatePriceList()
     

     
      },
      
      async updatePriceList()
      {
        
        this.spinner = true
        
        var data      = {'orderId' : this.orderId, 'productId' : this.productId,'priceList_0':this.priceList[0],'priceList_1':this.priceList[1],'discount':this.discountList.discount,'discount2':this.discountList.discount2,'discount3':this.discountList.discount3}
      
              
        var sp        = {'sp' : 'spUpdateSupplierOrderProductPriceList'}
        var json      = Object.assign(data, sp);
        
        

        await api.post(json).then(res => {
          if(res.status==200)
            {
              this.$emit('update')         
            }
            else if(res.status==500)
            {
              console.log(res.data)

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
          console.log(err.message)    
        }).finally(() => {
          this.spinner = false
        });
         
    
     
      }
      


      
  }
  
}
</script>

<style scoped>
.inputClass{
  font-weight       : bold;
}

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 14px;
}
.pointer{
  cursor: pointer;
}

</style>